// tslint:disable:no-commented-code

import { PartialIDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createSquarePanelFromList } from './square-panel-from-list';
import { ids } from './square-panel-template';

function createSquarePanelFromListSingleProduct() {
  const squarePanelFromList = createSquarePanelFromList();
  squarePanelFromList.root.data.nrOfProductsToShow = 1;

  squarePanelFromList.productDataContainer.data.panelName =
    'square-panel-from-list-single-product';

  return squarePanelFromList;
}

export const squarePanelFromListSingleProduct = mergeMultipleConfigs(
  createSquarePanelFromListSingleProduct().styleWrapper,
  [
    {
      id: ids.loadingSkeletonItem,
      styles: {
        classes: ['d-block', 'col-12', 'mb-1', 'mt-4'],
      },
    },
    {
      id: ids.squarePanelItemContentWrapper,
      styles: {
        classes: ['d-block', 'col', 'mb-2'],
      },
    },
  ],
) as PartialIDynamicItem;
